/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { initialState } from '../../redux/reducers/seasons';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import AddSeason from './atom/AddSeason';
import Season from './atom/Season';
import { SeuilsApi } from '../../utils/api';
import { SET_COUNT, SET_SEUIL_UPDATE } from '../../redux/actionType';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { makeAsDate } from './ecpHelper';
import ErrorParameter from '../../components/common/ErrorParameter';
import { loaderDataComponent } from '../../utils/helper';
declare type BreakProps = {
  id?: string;
  token: string;
  mainInstallCode: string;
};

const FormSeason = ({ mainInstallCode }: BreakProps) => {
  // store
  const dispatch = useDispatch();
  //form variable
  const [error, setError] = useState(false);
  const toast = useRef<any>(null);
  const [form, setForm] = React.useState<any>();
  const [seuils, setSeuils] = React.useState<any>();
  const [level, setLevel] = React.useState<number>(0);
  const seasonCount = useSelector((state: typeof initialState) => state.count);
  const [loading, setLoading] = useState(false);
  
  //get api data
  const getSeason = async () => {
    setLoading(true);
    try {
      const getSeasonParam = SeuilsApi.getSeasonParam(mainInstallCode);
      const getSeuilParameters = SeuilsApi.getSeuilParameters(mainInstallCode);
      const [getSeasons, getSeuil] = await Promise.allSettled([getSeasonParam, getSeuilParameters]);

      if(getSeasons.status === 'fulfilled'){
        setForm({
          id: getSeasons.value.data.id,
          s1beginMonth: getSeasons.value.data.s1beginMonth,
          s1endMonth: getSeasons.value.data.s1endMonth,
          s2beginMonth: getSeasons.value.data.s2beginMonth,
          s2endMonth: getSeasons.value.data.s2endMonth,
          s3beginMonth: getSeasons.value.data.s3beginMonth,
          s3endMonth: getSeasons.value.data.s3endMonth,
          s4beginMonth: getSeasons.value.data.s4beginMonth,
          s4endMonth: getSeasons.value.data.s4endMonth,
        });

        // test s'il y a déjà des saisons
        if (getSeasons.value.data?.s4beginMonth !== null) {
          setLevel(3);
          dispatch({
            type: SET_COUNT,
            payload: 3,
          });
        } else if (getSeasons.value.data?.s3beginMonth !== null) {
          setLevel(2);
          dispatch({
            type: SET_COUNT,
            payload: 2,
          });
        } else if (getSeasons.value.data?.s2beginMonth !== null) {
          setLevel(1);
          dispatch({
            type: SET_COUNT,
            payload: 1,
          });
        } else {
          setLevel(0);
          dispatch({
            type: SET_COUNT,
            payload: 0,
          });
        }
      } else {
        setError(true);
      }

      if(getSeuil.status === 'fulfilled'){
        setSeuils({
          id: getSeuil.value.data.id,
          tresholdS1Max: getSeuil.value.data.tresholdS1max,
          tresholdS1Min: getSeuil.value.data.tresholdS1min,
          tresholdS2Max: getSeuil.value.data.tresholdS2max,
          tresholdS2Min: getSeuil.value.data.tresholdS2min,
          tresholdS3Max: getSeuil.value.data.tresholdS3max,
          tresholdS3Min: getSeuil.value.data.tresholdS3min,
          tresholdS4Max: getSeuil.value.data.tresholdS4max,
          tresholdS4Min: getSeuil.value.data.tresholdS4min,
        });
      } else {
        setError(true);
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getSeason();
    }
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setLevel(seasonCount);
  }, [seasonCount]);

  //Methode pour rajouter  une saison à chaque clique
  //et supprimer une saison quand on clique supprimer

  const showSeason = () => {
    let seasonContent: any = [];
    for (let i = 0; i <= level; i++) {
      seasonContent.push(
        <div id={'div-season-' + i} key={i}>
          {form ? (
            <Season
              seasonStart={makeAsDate(form[`s${i + 1}beginMonth`])}
              seasonEnd={makeAsDate(form[`s${i + 1}endMonth`])}
              seasonTitle={'Saison ' + (i + 1)}
              showDeletion={i === level}
              sendNewBegin={(d: any) => {
                setForm((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`s${i + 1}beginMonth`]: d ? parseInt(d.value) : null,
                  };
                });
                setSeuils((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`tresholdS${i + 1}Min`]: d !== null ? 5 : null,
                  };
                });
              }}
              sendNewEnd={(d: any) => {
                setForm((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`s${i + 1}endMonth`]: d ? parseInt(d.value) : null,
                  };
                });
                setSeuils((oldValues: any) => {
                  return {
                    ...oldValues,
                    [`tresholdS${i + 1}Max`]: d !== null ? 95 : null,
                  };
                });
              }}
            />
          ) : null}
        </div>
      );
    }
    return seasonContent;
  };

  const getSeuilParameters = async () => {
    try {
      const seuilsResponse = await SeuilsApi.getSeuilParameters(mainInstallCode);
      if (seuilsResponse.status === 200) {
        setSeuils({
          id: seuilsResponse.data.id,
          tresholdS1Max: seuilsResponse.data.tresholdS1max,
          tresholdS1Min: seuilsResponse.data.tresholdS1min,
          tresholdS2Max: seuilsResponse.data.tresholdS2max,
          tresholdS2Min: seuilsResponse.data.tresholdS2min,
          tresholdS3Max: seuilsResponse.data.tresholdS3max,
          tresholdS3Min: seuilsResponse.data.tresholdS3min,
          tresholdS4Max: seuilsResponse.data.tresholdS4max,
          tresholdS4Min: seuilsResponse.data.tresholdS4min,
        });
        dispatch({
          type: SET_SEUIL_UPDATE,
          payload: true,
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de la récupération des paramètres de seuils',
          life: 5000,
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des seuils:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la récupération des seuils. Veuillez réessayer.',
        life: 7000,
      });
    }
  };

  const updateSeuilParameters = async (seuils: any) => {
    try {
      const updateSeuilResponse = await SeuilsApi.updateSeuilParameters(seuils);
      if (updateSeuilResponse.status === 200) {
        getSeuilParameters();
        toast.current?.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Paramètres de seuils mis à jour avec succès',
          life: 5000,
        });
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de la mise à jour des paramètres de seuils',
          life: 5000,
        });
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour des seuils:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la mise à jour des seuils. Veuillez réessayer.',
        life: 7000,
      }); 
    }
  }

  //api value and form data
  const handleOnSubmit = async () => {
    setLoading(true);
    try { 
      const updateSeasonResponse = await SeuilsApi.updateSeasonParam(form);
      // Vérifier les réponses des deux appels
      if (updateSeasonResponse.status === 200) {
        updateSeuilParameters(seuils);
        toast.current?.show({
          severity: 'success',
          summary: 'Succès',
          detail: 'Saisons mises à jour avec succès',
          life: 5000,
        });
      } else {
        // Gestion des erreurs
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail:
            "Les saisons doivent être consécutives et couvrir toute l'année",
          life: 7000,
        });
      }
  
    } catch (e) {
      // Gestion des erreurs
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail:
          "Erreur lors de la mise à jour des saisons. Veuillez réessayer.",
        life: 7000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      automatedTestId='form-season-global-container'
      className='form-season-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Form className='seasonForm' onSubmit={handleOnSubmit}>
        <Container className='form-season-global-content'>
          <Container className='form-season-showed'>
            {showSeason()}
            <Container
              className={`${level !== 3 ? 'add-season' : 'hide-add-season'}`}
            >
              <AddSeason />
            </Container>
          </Container>
        </Container>
        <Container className='seasonButton'>
          {loading === false ? <StyledSectionButton>
            <Button
              automatedTestId='btn-season-validation'
              className='param-btn'
              mode='plain'
            >
              <Word
                variant='span'
                textStyle='normalBold'
                value='Enregistrer les modifications'
              />
            </Button>
          </StyledSectionButton> : <div style={{ display: 'flex', justifyContent: 'center', marginTop: '3vh' }}>{loaderDataComponent(loading)}</div>}
        </Container>
      </Form>
      {error ? (
        <ErrorParameter
          message="une erreur s'est produite. Veuillez réessayer"
          title=''
          IsVisible={error}
        />
      ) : null}
    </Container>
  );
}
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  .param-btn {
    margin-top: 3vh;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }
`;

const Styles = createGlobalStyle`

.form-season-global-container.sds-reset-style{
  .pi{
    font-family: 'primeicons';    
  }
  max-width: 90vw;
  margin-left: auto;
  margin-right: auto;
  .form-season-global-content{
    flex-direction: row;   
  }
  .form-season-showed{
    flex-direction: row;   
    margin-left: auto;
    margin-right: auto;
    .hide-add-season{
      display:none;
    }
  }
}
`;

export default FormSeason;
